module.exports = __webpack_public_path__ + "assets/img/t2.ab9a1a0b.png";